import { render, staticRenderFns } from "./AdminMarketerDataForm.vue?vue&type=template&id=b2641d76&"
import script from "./AdminMarketerDataForm.vue?vue&type=script&lang=js&"
export * from "./AdminMarketerDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports